import React from "react";
import { motion } from "framer-motion";

export default function PlayButton({
  onClick,
  disabled,
  label = "Play",
  variant = "primary",
  testId,
}) {
  const isPrimary = variant === "primary";
  const base =
    "inline-flex items-center justify-center gap-2 rounded-full px-7 py-3 text-[15px] tracking-[0.18em] uppercase transition-shadow";
  const styles = isPrimary
    ? "text-white"
    : "border border-[#D6CBB8] text-[#5C5268]";
  const bg = isPrimary ? { backgroundColor: "#1B6C7A" } : { backgroundColor: "transparent" };

  return (
    <motion.button
      data-testid={testId}
      onClick={onClick}
      disabled={disabled}
      whileHover={disabled ? {} : { y: -2, boxShadow: "0 10px 22px -10px rgba(27,108,122,0.6)" }}
      whileTap={disabled ? {} : { scale: 0.98 }}
      transition={{ duration: 0.4, ease: [0.4, 0, 0.2, 1] }}
      className={`${base} ${styles} ${disabled ? "opacity-40 cursor-not-allowed" : "cursor-pointer"}`}
      style={{
        fontFamily: "'Courier Prime', monospace",
        fontWeight: 500,
        ...bg,
      }}
    >
      {label}
    </motion.button>
  );
}
